import React, { Component, useState } from "react";
import PropTypes from "prop-types";
import { StyleSheet, Platform } from "react-native";
import { View } from "react-native";
import { Content, Button } from "native-base";
import Icon from "react-native-vector-icons/Ionicons";
import MDIcon from "react-native-vector-icons/MaterialIcons";
import Letter from "../../components/ui/Letter";
import { WebView } from "react-native-webview";
import { getWritingBoardHtml } from "../../utils/HanziWriterHelper";

const isIos = Platform.OS === "ios";

class WritingView extends Component {

    render() {
        const html = getWritingBoardHtml();
        const writingChar = html.replace("%char%", this.props.data.char)
        return (
            <>
                <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center", marginTop: 0 }}>
                    <Letter data={this.props.data}
                            syllableStyle={{fontSize: 32, color: '#000'}}
                            charVisible={false}
                            style={{
                                color: '#000',
                                //lineHeight: 25,
                                fontSize: 21,
                                //marginBottom: 15,
                            }}
                    />
                </View>
                <View style={{ width: 300, height: 330, marginTop: 20 }}>
                    <WebView
                        source={{ html: writingChar, baseUrl: "web/" }}
                        style={{ flex: 1 }}
                        mixedContentMode="always"
                        originWhitelist={["*"]}
                        ref={webView => (this.webView = webView)}
                        onMessage={event => {
                            this._handleWritingChar(event.nativeEvent.data);
                        }}
                    />
                </View>
                <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center", marginTop: 0 }}>
                    <Button
                        transparent
                        style={[styles.centerAlign, { marginRight: 20, height: 64 }]}
                        onPress={() => {
                            this.webView.postMessage("animate");
                        }}>
                        <View style={{width: 40, height: 40, borderRadius: 20,
                                      backgroundColor: '#6b6b74',
                                      alignItems: 'center', justifyContent: 'center'}}>
                            <Icon size={30} name="ios-play" color="#fff" />
                        </View>
                    </Button>
                    <Button
                        transparent
                        style={[styles.centerAlign, { marginLeft: 20, height: 64 }]}
                        onPress={() => {
                            this.webView.postMessage("quiz");
                        }}>
                        <View style={{width: 40, height: 40, borderRadius: 20,
                                      backgroundColor: '#6b6b74',
                                      alignItems: 'center', justifyContent: 'center'}}>
                            <MDIcon name="edit" size={30} color={"#fff"} style={{}}/>
                        </View>
                    </Button>
                </View>
            </>
        )
    }

    _handleWritingChar = message => {
        this.props.handleWritingChar && this.props.handleWritingChar(message);
    };
}

const styles = StyleSheet.create({
    centerAlign: {
        justifyContent: "center",
        alignItems: "center",
    },
});

WritingView.propTypes = {
    char: PropTypes.string,
    handleWritingChar: PropTypes.func,
};

WritingView.defaultValue = {
    char: "",
    handleWritingChar: null,
};

export default WritingView;
